import TransformationTypes from "@/js/lookups/transformation-types.js";

function DataTypes() {
    let transformationTypes = TransformationTypes.items;
    this.dataTypeToGenericType = (dataTypeId) => {
        if (!dataTypeId) {
            return null;
        }
        switch (dataTypeId) {
            case this.types.INTEGER:
            case this.types.DECIMAL:
            case this.types.PERCENTAGE:
            case this.types.PERCENTAGE_INT:
                return this.genericTypes.NUMBER;
                break;
            case this.types.CURRENCY_CENTS:
                return this.genericTypes.CURRENCY;
                break;
            case this.types.DATE_ISO8601:
            case this.types.DATE_MM_DD_YYYY:
            case this.types.UNIX_SECONDS:
            case this.types.UNIX_MILLISECONDS:
                return this.genericTypes.DATETIME;
                break;
            case this.types.BOOLEAN:
                return this.genericTypes.BOOLEAN;
                break;
            case this.types.STRING:
            default:
                return this.genericTypes.STRING;
                break;
        }
    };
    this.genericTypes = {
        STRING: {
            id: 1,
        },
        NUMBER: {
            id: 2,
        },
        DATETIME: {
            id: 3,
        },
        BOOLEAN: {
            id: 4,
        },
        CURRENCY: {
            id: 5,
        },
    };
    this.types = {
        STRING: {
            id: 1,
            genericTypeId: 1,
            transformationTypes: [
                transformationTypes.INTEGER.id,
                transformationTypes.DECIMAL.id,
                transformationTypes.BOOLEAN.id,
                transformationTypes.DATE_ISO8601.id,
                transformationTypes.DATE_MM_DD_YYYY.id,
                transformationTypes.DATE_DD_MM_YYYY.id,
                transformationTypes.DATE_ISO8601_TIME.id,
                transformationTypes.DATE_MM_DD_YYYY_TIME.id,
                transformationTypes.DATE_DD_MM_YYYY_TIME.id,
                transformationTypes.UNIX_SECONDS.id,
                transformationTypes.UNIX_MILLISECONDS.id,
                transformationTypes.CURRENCY.id,
                transformationTypes.PERCENTAGE.id,
            ],
        },
        INTEGER: {
            id: 2,
            genericTypeId: 2,
            transformationTypes: [],
        },
        DECIMAL: {
            id: 3,
            genericTypeId: 2,
            transformationTypes: [],
        },
        UNIX_SECONDS: {
            id: 4,
            genericTypeId: 3,
            transformationTypes: [
                transformationTypes.DATE_ISO8601.id,
                transformationTypes.DATE_MM_DD_YYYY.id,
                transformationTypes.DATE_DD_MM_YYYY.id,
                transformationTypes.DATE_ISO8601_TIME.id,
                transformationTypes.DATE_MM_DD_YYYY_TIME.id,
                transformationTypes.DATE_DD_MM_YYYY_TIME.id,
                transformationTypes.UNIX_SECONDS.id,
                transformationTypes.UNIX_MILLISECONDS.id,
            ],
        },
        UNIX_MILLISECONDS: {
            id: 5,
            genericTypeId: 3,
            transformationTypes: [
                transformationTypes.DATE_ISO8601.id,
                transformationTypes.DATE_MM_DD_YYYY.id,
                transformationTypes.DATE_DD_MM_YYYY.id,
                transformationTypes.DATE_ISO8601_TIME.id,
                transformationTypes.DATE_MM_DD_YYYY_TIME.id,
                transformationTypes.DATE_DD_MM_YYYY_TIME.id,
                transformationTypes.UNIX_SECONDS.id,
                transformationTypes.UNIX_MILLISECONDS.id,
            ],
        },
        DATE_ISO8601: {
            id: 6,
            genericTypeId: 3,
            transformationTypes: [
                transformationTypes.DATE_ISO8601.id,
                transformationTypes.DATE_MM_DD_YYYY.id,
                transformationTypes.DATE_DD_MM_YYYY.id,
                transformationTypes.DATE_ISO8601_TIME.id,
                transformationTypes.DATE_MM_DD_YYYY_TIME.id,
                transformationTypes.DATE_DD_MM_YYYY_TIME.id,
                transformationTypes.UNIX_SECONDS.id,
                transformationTypes.UNIX_MILLISECONDS.id,
            ],
        },
        DATE_MM_DD_YYYY: {
            id: 7,
            genericTypeId: 3,
            transformationTypes: [
                transformationTypes.DATE_ISO8601.id,
                transformationTypes.DATE_MM_DD_YYYY.id,
                transformationTypes.DATE_DD_MM_YYYY.id,
                transformationTypes.DATE_ISO8601_TIME.id,
                transformationTypes.DATE_MM_DD_YYYY_TIME.id,
                transformationTypes.DATE_DD_MM_YYYY_TIME.id,
                transformationTypes.UNIX_SECONDS.id,
                transformationTypes.UNIX_MILLISECONDS.id,
            ],
        },
        DATE_DD_MM_YYYY: {
            id: 8,
            genericTypeId: 3,
            transformationTypes: [
                transformationTypes.DATE_ISO8601.id,
                transformationTypes.DATE_MM_DD_YYYY.id,
                transformationTypes.DATE_DD_MM_YYYY.id,
                transformationTypes.DATE_ISO8601_TIME.id,
                transformationTypes.DATE_MM_DD_YYYY_TIME.id,
                transformationTypes.DATE_DD_MM_YYYY_TIME.id,
                transformationTypes.UNIX_SECONDS.id,
                transformationTypes.UNIX_MILLISECONDS.id,
            ],
        },
        CURRENCY_CENTS: {
            id: 9,
            genericTypeId: 5,
            transformationTypes: [transformationTypes.CURRENCY.id],
        },
        PERCENTAGE: {
            id: 10,
            genericTypeId: 2,
            transformationTypes: [],
        },
        PERCENTAGE_INT: {
            id: 11,
            genericTypeId: 2,
            transformationTypes: [],
        },
        BOOLEAN: {
            id: 12,
            genericTypeId: 4,
            transformationTypes: [],
        },
    };
}

export default DataTypes;
